export default __webpack_public_path__ + "static/media/ke.55d663b2.svg";